"use strict";
/**
 * use for example in debug console logs to reduce verboseness
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.showKeysPresent = void 0;
const showKeysPresent = (o) => {
    let missing = [];
    let present = [];
    Object.entries(o).forEach(([k, v]) => {
        if (v) {
            present.push(k);
        }
        else {
            missing.push(k);
        }
    });
    const str = `missing: ${missing.join(', ')}, present: ${present.join(', ')}`;
    return str;
};
exports.showKeysPresent = showKeysPresent;
